import { t } from '../../lib/i18n';
import { TotpEnrol } from '../../components/TotpEnrol';
import { AuthLayout, useProceed } from './AuthLayout';

/** Shown when two-factor is required (platform admins, or a tenant that insists) but not set up yet. */
export function TotpSetupPage() {
  const proceed = useProceed();
  return (
    <AuthLayout title={t('auth.totpSetupTitle')}>
      {/* The enable call does not report the next login stage, so we carry on as complete and the
          session guard sends us back to sign-in if the server still wants another step. */}
      <TotpEnrol onDone={() => proceed({ stage: 'complete' })} />
    </AuthLayout>
  );
}
